// extracted by mini-css-extract-plugin
export default {"scoreColumns":"SportsMatchScore_scoreColumns","score":"SportsMatchScore_score","scoreSecondary":"SportsMatchScore_scoreSecondary"};